@import "../../../global/temporary-mercury-overrides/_button.scss";

:host {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr max-content;
  block-size: 100%;
  overflow: auto;
}
.section {
  display: contents;
}
.main {
  display: grid;
  grid-template-rows: max-content 1fr max-content;
  block-size: 100%;
  overflow: auto;
}

.documents__header {
  grid-template-columns: 1fr max-content;
}
.documents__suggest {
  flex: 1;
}
